module.exports = __webpack_public_path__ + "img/scim.ee7a2aab.svg";